import React, { useState, useEffect } from "react";
import axios from "axios";
import { API_URL } from "../../config/api";

function Contact() {
  const [hoveredField, setHoveredField] = useState(null);
  const [contact, setContact] = useState({
    name: "Mohammed Junaid Hussain",
    gender: "Male",
    email: "junaidhussain798@outlook.com",
    age: "21",
  });
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchContact = async (retries = 3, delay = 1000) => {
      try {
        const response = await axios.get(`${API_URL}/contact`);
        if (response.data && response.data.success) {
          const contactData = response.data.data;
          setContact(Array.isArray(contactData) ? contactData[0] : contactData);
        } else if (response.data && response.data.length > 0) {
          setContact(response.data[0]);
        }
        setLoading(false);
      } catch (error) {
        if (error.response?.status === 429 && retries > 0) {
          console.log(
            `Rate limited. Retrying in ${delay}ms... (${retries} attempts left)`
          );
          setTimeout(() => fetchContact(retries - 1, delay * 2), delay);
          return;
        }
        console.error("Error fetching contact:", error);
        setLoading(false);
      }
    };

    fetchContact();
  }, []);

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <div className="text-white/30 text-sm tracking-wider uppercase">
          Loading...
        </div>
      </div>
    );
  }

  return (
    <div className="min-h-screen py-16 sm:py-20 px-4 sm:px-6 flex flex-col items-center justify-center relative overflow-hidden">
      {/* Minimal animated background grid */}
      <div className="absolute inset-0 opacity-[0.02]">
        <div
          className="absolute inset-0"
          style={{
            backgroundImage: `linear-gradient(rgba(255,255,255,0.05) 1px, transparent 1px),
                           linear-gradient(90deg, rgba(255,255,255,0.05) 1px, transparent 1px)`,
            backgroundSize: "50px 50px",
          }}
        ></div>
      </div>

      {/* Floating orb - subtle */}
      <div className="absolute top-1/4 right-1/4 w-96 h-96 bg-white/[0.01] blur-[120px] rounded-full animate-pulse"></div>

      <div className="max-w-5xl w-full relative z-10">
        {/* Title with understated elegance */}
        <div className="mb-12 sm:mb-16 md:mb-20 text-center">
          <div className="inline-block relative">
            <h2 className="text-4xl sm:text-5xl md:text-7xl font-light tracking-tight text-white/90 mb-2">
              Say Hello
            </h2>
            <div className="h-[1px] w-12 sm:w-16 bg-gradient-to-r from-transparent via-white/40 to-transparent mx-auto mt-3 sm:mt-4"></div>
          </div>
        </div>

        {/* Main content container */}
        <div className="flex lg:flex-row flex-col items-center justify-center gap-10 sm:gap-14 md:gap-20">
          {/* Contact information - refined card */}
          <div className="w-full lg:w-auto">
            <div
              className="bg-white/[0.02] border border-white/[0.06] backdrop-blur-sm rounded-2xl sm:rounded-3xl p-6 sm:p-8 md:p-12 
                          shadow-2xl shadow-black/50 hover:border-white/10 transition-all duration-700
                          hover:shadow-white/[0.02] hover:shadow-2xl group"
            >
              {/* JSON structure with micro-interactions */}
              <div className="font-mono text-xs sm:text-sm md:text-base text-gray-400 space-y-1">
                <div className="text-white/60 mb-3">{`{`}</div>

                {Object.entries(contact)
                  .filter(
                    ([key]) =>
                      !["_id", "__v", "createdAt", "updatedAt"].includes(key)
                  )
                  .map(([key, value], idx) => (
                    <div
                      key={idx}
                      onMouseEnter={() => setHoveredField(key)}
                      onMouseLeave={() => setHoveredField(null)}
                      className="pl-4 sm:pl-6 py-1.5 sm:py-2 rounded-lg transition-all duration-300 cursor-default
                             hover:bg-white/[0.02] hover:pl-6 sm:hover:pl-8"
                    >
                      <span className="text-white/40 mr-1 sm:mr-2">{key}</span>
                      <span className="text-white/20">: </span>
                      <span
                        className={`transition-all duration-300 break-all ${
                          hoveredField === key
                            ? "text-white/90"
                            : "text-white/50"
                        }`}
                      >
                        "{value}"
                      </span>
                      <span className="text-white/10">,</span>
                    </div>
                  ))}

                <div className="text-white/60 mt-3">{`}`}</div>
              </div>

              {/* Subtle hover indicator */}
              <div className="mt-8 pt-6 border-t border-white/[0.04]">
                <div className="flex items-center gap-2 text-white/30 text-xs tracking-wider">
                  <div className="w-1.5 h-1.5 rounded-full bg-white/20 animate-pulse"></div>
                  <span>AVAILABLE FOR OPPORTUNITIES</span>
                </div>
              </div>
            </div>
          </div>

          {/* Abstract visual element - geometric */}
          <div className="w-full lg:w-auto hidden lg:flex items-center justify-center">
            <div className="relative w-80 h-80">
              {/* Rotating rings */}
              <div className="absolute inset-0 flex items-center justify-center">
                <div className="absolute w-64 h-64 border border-white/[0.08] rounded-full animate-spin-slow"></div>
                <div
                  className="absolute w-48 h-48 border border-white/[0.06] rounded-full animate-spin-slower"
                  style={{ animationDirection: "reverse" }}
                ></div>
                <div className="absolute w-32 h-32 border border-white/[0.04] rounded-full animate-spin-slow"></div>
              </div>

              {/* Center element */}
              <div className="absolute inset-0 flex items-center justify-center">
                <div className="relative">
                  <div
                    className="w-20 h-20 bg-white/[0.03] backdrop-blur-xl rounded-2xl 
                                border border-white/[0.08] flex items-center justify-center
                                shadow-2xl shadow-white/[0.02] hover:scale-110 transition-transform duration-500"
                  >
                    <svg
                      className="w-8 h-8 text-white/40"
                      fill="none"
                      viewBox="0 0 24 24"
                      stroke="currentColor"
                    >
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth={1.5}
                        d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z"
                      />
                    </svg>
                  </div>

                  {/* Pulsing dots */}
                  <div className="absolute -top-2 -right-2 w-3 h-3 bg-white/40 rounded-full animate-ping"></div>
                  <div className="absolute -top-2 -right-2 w-3 h-3 bg-white/60 rounded-full"></div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <style>{`
        @keyframes spin-slow {
          from { transform: rotate(0deg); }
          to { transform: rotate(360deg); }
        }
        @keyframes spin-slower {
          from { transform: rotate(0deg); }
          to { transform: rotate(360deg); }
        }
        .animate-spin-slow {
          animation: spin-slow 20s linear infinite;
        }
        .animate-spin-slower {
          animation: spin-slower 30s linear infinite;
        }
      `}</style>
    </div>
  );
}

export default Contact;
